var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortRegular = function SvgSortRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.283 4.533a.75.75 0 0 1-1.06-1.06L11.47.223a.747.747 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1-1.06 1.06l-1.968-1.97V15.25c0 .416-.335.75-.75.75a.75.75 0 0 1-.75-.75V2.562L9.282 4.53zm-8 6.937 1.969 1.968V.75c0-.416.334-.75.75-.75.415 0 .75.334.75.75v12.688L6.72 11.47a.75.75 0 0 1 1.06 1.06l-3.25 3.248a.747.747 0 0 1-1.06 0L.22 12.532a.75.75 0 0 1 1.06-1.06z"
  })));
};
export default SvgSortRegular;